import React, { useState, useEffect } from "react";
import { FaCode } from "react-icons/fa";
import Career from "../../../assests/careerNew.png";

const JobSection = ({ setSelectedRole, scrollToForm }) => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [limit] = useState(9);
  const [search, setSearch] = useState("");
  const [location, setLocation] = useState("");

  const openModal = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedJob(null);
    setIsModalOpen(false);
  };

  const fetchJobs = async (currentPage = 1) => {
    try {
      setLoading(true);

      let url = `https://api.tekitsolution.com/api/public/jobs?page=${currentPage}&limit=${limit}&job_type=full-time`;

      if (search) url += `&search=${search}`;
      if (location) url += `&location=${location}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();

      setJobs(data?.data || []);
      setTotalPages(data?.meta?.totalPages || 1);
    } catch (error) {
      console.log("Job API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs(page);
  }, [page, search, location]);

//  const scrollToForm = () => {
//   const el = document.getElementById("career-form");
//   if (el) {
//     el.scrollIntoView({ behavior: "smooth" });
//   }
// };
  return (
    <>
      {/* Banner */}
      <div
        style={{
          backgroundImage: `url(${Career})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="lg:h-[360px] flex justify-center flex-col items-center w-full text-white p-6 shadow-xl text-center"
      >
        <h3 className="text-[46px] font-bold">Find Your Dream Role</h3>
        <p className="text-[18px] mt-2">
          Explore roles crafted for growth and innovation
        </p>
      </div>

      <div className="relative w-full px-6 pb-12 mt-[10px]">
        <div className="w-full lg:w-[80%] bg-white shadow-md rounded-xl mx-auto px-8 py-12 relative">
          <h2 className="text-[42px] font-bold text-center mb-10">
            Current Openings
          </h2>

          {/* Filters */}
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <input
              type="text"
              placeholder="Search Jobs..."
              className="border p-3 rounded-lg"
              value={search}
              onChange={(e) => {
                setPage(1);
                setSearch(e.target.value);
              }}
            />

            <input
              type="text"
              placeholder="Filter by Location"
              className="border p-3 rounded-lg"
              value={location}
              onChange={(e) => {
                setPage(1);
                setLocation(e.target.value);
              }}
            />
          </div>

          {/* Jobs Grid */}
          {loading ? (
            <div className="text-center py-10 text-xl font-semibold">
              Loading Jobs...
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {jobs.map((job) => (
                <div
                  key={job.id}
                  className="group bg-white border border-gray-200 shadow-lg rounded-2xl p-6 transition duration-300 hover:scale-[1.02] hover:shadow-2xl cursor-pointer"
                  onClick={() => {
                    setSelectedRole(job.title);
                    setSelectedJob(job);
                    scrollToForm();
                  }}
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className="bg-[#fef2f2] p-3 rounded-lg">
                      <FaCode className="text-[#f76b4f] text-xl" />
                    </div>

                    <div>
                      <h3 className="text-[22px] font-semibold text-[#031B59]">
                        {job.title}
                      </h3>
                      <p className="text-sm text-[#646978] mt-1">
                        {job.experience}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mt-2">
                    <span className="text-sm px-3 py-1 bg-[#F3F6FD] rounded-full">
                      {job.job_type}
                    </span>

                    <span className="text-sm px-3 py-1 bg-[#F3F6FD] rounded-full">
                      {job.location}
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-2 mt-3">
                    <span className="text-sm px-3 py-1 bg-[#F3F6FD] rounded-full">
                      {job.vacancy}
                    </span>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openModal(job);
                      }}
                      className="text-sm px-3 py-1 bg-[#F3F6FD] rounded-full text-[#09588D] underline"
                    >
                      View Description
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-2 mt-10 flex-wrap">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className="px-4 py-2 rounded border disabled:opacity-40"
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  className={`w-10 h-10 rounded ${
                    page === i + 1
                      ? "bg-[#031B59] text-white"
                      : "bg-gray-100 text-black"
                  }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
                className="px-4 py-2 rounded border disabled:opacity-40"
              >
                Next
              </button>
            </div>
          )}
        </div>

        {/* Modal */}
        {isModalOpen && selectedJob && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4"
            onClick={closeModal}
          >
            <div
              className="bg-white p-6 max-w-3xl w-full relative overflow-y-auto max-h-[75vh] rounded-xl shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-3 right-4 text-2xl text-gray-500 hover:text-red-500"
                onClick={closeModal}
              >
                ×
              </button>

             <div className="flex items-center justify-between gap-4 mt-6 mb-4">
  
  <h2 className="text-2xl font-bold text-[#031B59]">
    {selectedJob.title}
  </h2>

  <button
    onClick={() => {
      setSelectedRole(selectedJob.title);
      closeModal();
      scrollToForm();
    }}
    className="bg-[#031B59] text-white px-6 py-2 rounded-lg hover:bg-[#09588D] whitespace-nowrap"
  >
    Apply Now
  </button>

</div>
              <div className="grid md:grid-cols-2 gap-3 mb-5 text-sm">
                <p>
                  <strong>Experience:</strong> {selectedJob.experience}
                </p>
                <p>
                  <strong>Location:</strong> {selectedJob.location}
                </p>
                <p>
                  <strong>Notice Period:</strong> {selectedJob.notice_period}
                </p>
                <p>
                  <strong>Vacancy:</strong> {selectedJob.vacancy}
                </p>
              </div>

              <div className="border-t pt-4">
                <h3 className="font-semibold text-[#09588D] mb-2">
                  Job Description
                </h3>

                <div
                  className="text-sm text-gray-700 leading-7"
                  dangerouslySetInnerHTML={{
                    __html: selectedJob?.description || "",
                  }}
                />
              </div>

              {selectedJob?.mandatory_skills?.length > 0 && (
                <div className="mt-5 border-t pt-4">
                  <h3 className="font-semibold text-[#09588D] mb-2">
                    Mandatory Skills
                  </h3>

                  <ul className="list-disc pl-5 text-sm text-gray-700 space-y-2">
                    {selectedJob.mandatory_skills.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedJob?.responsibilities?.length > 0 && (
  <div className="mt-5 border-t pt-4">
    <h3 className="font-semibold text-[#09588D] mb-2">
      Responsibilities
    </h3>

    <ul className="list-disc pl-5 text-sm text-gray-700 space-y-2">
      {selectedJob.responsibilities.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  </div>
)}

{selectedJob?.good_to_have_skills?.length > 0 && (
  <div className="mt-5 border-t pt-4">
    <h3 className="font-semibold text-[#09588D] mb-2">
      Good to Have Skills
    </h3>

    <ul className="list-disc pl-5 text-sm text-gray-700 space-y-2">
      {selectedJob.good_to_have_skills.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  </div>
)}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default JobSection;